import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

const testimonials = [
  {
    quote: "The Personality Breakthrough Profile gave me insights I never thought possible. It's helped me grow personally and professionally.",
    author: "Sarah J.",
    role: "Life Coach"
  },
  {
    quote: "As a trainer, I've integrated The Personality Breakthrough Profile into my programs. The results speak for themselves!",
    author: "James M.",
    role: "Breakthrough Coach"
  }
];

export function TestimonialsSection() {
  return (
    <section id="testimonials" className="py-20 px-4">
      <div className="w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16 w-full"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What Our Users Say
          </h2>
          <p className="text-gray-600 text-lg w-full">
            Real experiences from professionals who've transformed their practice
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 w-full">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`rounded-3xl shadow-sm hover:shadow-md transition-all duration-300 hover:scale-[1.02] ${
                index === 0 ? 'bg-blue-50 border border-blue-100' : 'bg-emerald-50 border border-emerald-100'
              }`}
            >
              <div className="p-10 h-full min-h-[300px] flex flex-col justify-between">
                <div>
                  <Quote className={`w-16 h-16 mb-6 ${
                    index === 0 ? 'text-blue-600' : 'text-emerald-600'
                  }`} />
                  <p className="text-gray-800 text-xl mb-8 leading-relaxed font-medium">
                  {testimonial.quote}
                  </p>
                </div>
                <div>
                  <p className="text-gray-900 font-bold text-lg">{testimonial.author}</p>
                  <p className="text-gray-600 text-lg">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}